// Configuration for Microsoft Authentication Library (MSAL)
import { PublicClientApplication, LogLevel, BrowserCacheLocation } from "@azure/msal-browser";
import { ENV_CONFIG } from '../../config/environment';

// Debug: Log environment configuration in development
if (process.env.NODE_ENV === 'development') {
  console.log('MSAL Environment Configuration:', {
    CLIENT_ID: ENV_CONFIG.AZURE.CLIENT_ID ? ENV_CONFIG.AZURE.CLIENT_ID.substring(0, 8) + '...' : 'undefined',
    TENANT_ID: ENV_CONFIG.AZURE.TENANT_ID ? ENV_CONFIG.AZURE.TENANT_ID.substring(0, 8) + '...' : 'undefined',
    AUTHORITY: ENV_CONFIG.AZURE.AUTHORITY || 'undefined',
    REDIRECT_URI: ENV_CONFIG.AZURE.REDIRECT_URI || 'undefined',
    CURRENT_ORIGIN: typeof window !== 'undefined' ? window.location.origin : 'server-side'
  });
}

// Get the window object safely for SSR environments
const getWindowOrigin = () => {
  if (typeof window !== "undefined") {
    // During development, use localhost, in production use the configured URI
    const currentOrigin = window.location.origin;
    
    // If we're in development (localhost), use current origin
    if (currentOrigin.includes('localhost') || currentOrigin.includes('127.0.0.1')) {
      console.log('Development mode detected, using current origin:', currentOrigin);
      return currentOrigin;
    }
    
    // In production, use the configured redirect URI or current origin as fallback
    const configuredUri = ENV_CONFIG.AZURE.REDIRECT_URI;
    if (configuredUri && configuredUri !== currentOrigin) {
      console.log('Production mode, using configured redirect URI:', configuredUri);
      return configuredUri;
    }
    
    return currentOrigin;
  }
  
  // Fallback for SSR
  return ENV_CONFIG.AZURE.REDIRECT_URI;
};

// MSAL configuration parameters
export const msalConfig = {
  auth: {
    clientId: ENV_CONFIG.AZURE.CLIENT_ID,
    authority: ENV_CONFIG.AZURE.AUTHORITY,
    redirectUri: getWindowOrigin(),
    postLogoutRedirectUri: getWindowOrigin(),
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: true,
  },
  system: {
    allowRedirectInIframe: true,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
      piiLoggingEnabled: false
    },
  },
};

// Login request object with scopes
export const loginRequest = {
  scopes: ["User.Read"],
  prompt: "select_account",
};

// Create and initialize the MSAL instance properly for browser environments
let msalInstance = null;

if (typeof window !== "undefined") {
  msalInstance = new PublicClientApplication(msalConfig);
  // Note: Do not initialize here - let AuthProvider handle initialization
  // This prevents double initialization which causes interaction_in_progress errors
}

export { msalInstance };